import { CANDIDACY_PILL, pillFor } from '@/shared/utils/statusPills';

// Thin view of the one candidacy map in statusPills.js, kept for callers that
// read bg and label directly.
// `unavailable` is a reviewer-side wording the server never stores, so it is
// not one of the stored stages.
const { unavailable: _unavailable, ...STORED_STAGES } = CANDIDACY_PILL;
export const CANDIDACY_STAGE = Object.freeze(STORED_STAGES);

// The server's OPEN_STAGES (server/src/services/candidacyStages.js):
// withdrawing the student application withdraws candidacies in these.
export const OPEN_CANDIDACY_STAGES = Object.freeze([
    'applied',
    'screening',
    'interview',
    'finalist',
    'offered',
    'expired',
]);

// The stages in which a candidacy holds its position: the server's
// OPEN_STAGES plus 'accepted' (positionsRefusal in
// server/src/services/positionChoices.js). A released candidacy holds nothing.
export const HELD_CANDIDACY_STAGES = Object.freeze([
    ...OPEN_CANDIDACY_STAGES,
    'accepted',
]);

// Where the student is offered "Withdraw from this position". An offer is
// declined instead.
export const WITHDRAWABLE_STAGES = Object.freeze([
    'applied',
    'screening',
    'interview',
    'finalist',
]);

// The server's APPLYING_STATUSES (server/src/services/candidacyService.js):
// the student application statuses that let a student apply to positions.
export const PROFILE_APPLYING_STATUSES = Object.freeze([
    'submitted',
    'under_review',
    'interview_scheduled',
    'offered',
    'accepted',
]);

export function candidacyStageOf(stage) {
    return pillFor('candidacy', stage);
}

export function candidacyFor(candidacies, { applicationId, program }) {
    return (
        (candidacies || []).find(
            (c) => c.applicationId === applicationId && c.program === program
        ) || null
    );
}

export function candidaciesForProfile(candidacies, { program, term }) {
    return (candidacies || []).filter(
        (c) => c.program === program && c.term === term
    );
}

export function openCandidacyCount(candidacies, { program, term }) {
    return candidaciesForProfile(candidacies, { program, term }).filter((c) =>
        OPEN_CANDIDACY_STAGES.includes(c.stage)
    ).length;
}
